import { BasketContentFavoriteItem } from './BasketContentFavoriteItem';

export function BasketContentFavorite(props) {
    const { items, actions } = props;

    return (
        <div className="show-box active-group" id="save-for-later-box">
            {items.map((item, index) => (<BasketContentFavoriteItem item={item} actions={actions} key={`${item.fabric.id}-${index}`} />))}
            {items.length === 0 && <div className="body-text3 mt-32 active">You have no items in your Save for later list.</div>}
        </div>
    );
}